import React from 'react'
import Navbar from "../inc/Navbar";
import mrindiancoder from "../images/WEBSITE DEVELOPED BY MR. INDIAN CODER.jpg";
import logo_mrindiancoder from "../images/MR. INDIAN CODER FINAL LOGO Update 04 Sep, 2025.jpg";
import ContactForm from './ContactFrom';
import Reviews from './Reviews';
import Develop from './Develop';
import { Contactformnew } from './ContactfromNew';

function BookAppoint() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
<br/>
        <br/>

     

        <div className="kalyaniwebsiteservice">
               <br/>
        
        <div className="album py-0">
          <div className="container">
            <center>
              <img src={logo_mrindiancoder} className="mb-2 mt-1" width="110" height="34" alt="logo_mrindiancoder" />
            </center>
            <center>
              <h2 style={{ color: "#553C1E" }}>MR. INDIAN CODER</h2>
               
            </center>

          </div>
        </div>
   
        <div className="album py-0">
          <div className="container">
            <div className="row">
              <div className="col-md-7 mt-3">
              <center>
                 <h5 className="mt-0 mb-3"><b>Book expert consultancy, guidance, and a professional website.</b></h5>
              </center>
                <Contactformnew />
              </div>
              <div className="col-md-5 mt-4">
                <img src={mrindiancoder} className="d-block w-100" alt="Rmrindiancoder" />

              </div>
            </div>
          </div>
        </div>
        <br/>
        <br/>
         <br/>
    
        <Develop/>
       
        <div className="album py-0">
                <div className="container">
             <h1 style={{color:"grey"}}> Reviews from Our Hon'ble Clients</h1>
                    </div>
                    </div>
        <Reviews/>
        <br/>
      </div>


        
        
    </div>
  )
}

export default BookAppoint